export default {"src":"/_next/static/media/icGift2.9686ae68.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};